import StoragesList from "features/storages/StoragesList"
import { useTranslation } from "react-i18next"
import { ReactComponent as AddIcon } from "assets/icons/add.svg"
import Section from "components/layout/section"
import RightSidebar from "components/sidebar/right/RightSidebar"
import Button from "components/inputs/button"
import PageTitle from "features/navigation/pageTitle"
import { MainSheetHeaderActions } from "@/components/layout/layoutChrome"

const StoragesPage = () => {

    const { t } = useTranslation()

    return (
        <>
            <PageTitle title={t('titleStorages')} />
            <MainSheetHeaderActions>
                <Button wideOnMobile design="primary" to="/storages/create"><AddIcon /><span>{t(`buttonNewStorage`)}</span></Button>
            </MainSheetHeaderActions>
            <Section>
                <StoragesList />
            </Section>
            <RightSidebar />
        </>
    )
}

export default StoragesPage

